// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldSave = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        id: 'vuesax/linear/save-2',
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          id: 'save-2',
        },
        /*#__PURE__*/ React.createElement('path', {
          id: 'Vector',
          d: 'M15.8959 3.9375H8.11584C6.40584 3.9375 5.00586 5.33749 5.00586 7.04749V18.4075C5.00586 19.8575 6.04586 20.4775 7.31586 19.7675L11.2458 17.5775C11.6658 17.3475 12.3459 17.3475 12.7559 17.5775L16.6859 19.7675C17.9559 20.4775 18.9958 19.8575 18.9958 18.4075V7.04749C19.0058 5.33749 17.6059 3.9375 15.8959 3.9375Z',
          fill: 'currentColor',
        }),
      ),
    ),
  );

export { IconBoldSave };
